const generateSequence = (map, from, to) => {
  const mapKeys = Object.keys(map);
  const items = [];
  if (from > to) return items;

  let total = from;
  while (total <= to) {
    items.push(total);
    // eslint-disable-next-line no-loop-func
    const mapKeyIdx = mapKeys.findIndex((k) => k > total);
    const mapKey = mapKeys[mapKeyIdx - 1] || mapKeys[mapKeys.length - 1];
    const mapValue = map[mapKey];
    total += mapValue;
  }

  return items;
};

export default generateSequence;
